// extracted by mini-css-extract-plugin
export var afilinlk = "affiliate-module--afilinlk--dce85";